import { api } from '../api';

export interface LookupAssociationMember {
  memberId: number;
  slotKey: string;
  slotLabel: string;
  entityId: number;
  identifier: string;
  displayName: string;
  entityType: { id: number; code: string; name: string };
}

export interface LookupItem {
  entity: {
    id: number;
    identifier: string;
    displayName: string;
    status: string;
    entityType: { id: number; code: string; name: string };
    context: { id: number; path: string } | null;
  };
  compliance: {
    status: 'compliant' | 'non_compliant' | 'partial' | 'unknown';
    requirementsOk: number;
    requirementsTotal: number;
    expiringIn7d: number;
    expiringIn30d: number;
  };
  documents: Array<{
    id: number;
    documentTypeId: number;
    documentTypeName: string;
    status: string;
    expiresAt: string | null;
    fileName: string;
  }>;
  associations: Array<{
    id: number;
    name: string | null;
    associationType: { id: number; code: string; name: string };
    context: { id: number; path: string } | null;
    slotKey: string;
    memberId: number;
    complianceStatus: string | null;
    compliance: { percent: number; ok: number; total: number };
    members: LookupAssociationMember[];
  }>;
  permissions: {
    canUploadDoc: boolean;
    canEditEntity: boolean;
    canViewAssociations: boolean;
  };
}

export interface LookupResponse {
  query: string;
  items: LookupItem[];
  entities: LookupItem[];
  total: number;
}

export interface LookupParams {
  q: string;
  entityTypeCode?: string;
  contextId?: number;
  limit?: number;
}

export const lookupApi = api.injectEndpoints({
  endpoints: (builder) => ({
    lookupEntities: builder.query<LookupResponse, LookupParams>({
      query: (params) => {
        const search = new URLSearchParams();
        search.set('q', params.q.slice(0, 128));
        if (params.entityTypeCode) {
          search.set('entityTypeCode', params.entityTypeCode.slice(0, 64));
        }
        if (params.contextId) {
          search.set('contextId', String(params.contextId));
        }
        if (params.limit) {
          search.set('limit', String(Math.min(params.limit, 50)));
        }
        return `/entities/lookup?${search.toString()}`;
      },
      providesTags: ['Entity', 'Document', 'Association'],
    }),
  }),
});

export const { useLookupEntitiesQuery, useLazyLookupEntitiesQuery } = lookupApi;
